
angular.module('mtic.components.login').component('mticPostIamRegistrationModuleOption', {
  templateUrl: 'template.html',
  bindings: {
    id: '<',
    name: '<',
    infos: '<',
    select: '<',
    isSelected: '<'
  },
  controllerAs: 'moduleOption',
  controller() {
    const moduleOption = this;
    moduleOption.iconClass = function() {
      if(moduleOption.isSelected(moduleOption)) {
        return {
          'button': true,
          'is-info': true,
        }
      }else{
        return {
          'button': true,
          'is-info': true,
          'is-outlined': true,
        }
      }
    }
  }
})
